import { Row } from "react-table";

export function defaultTextContainsFilter(rows: Row<Object>[], id: string, filterValue: string): Row<Object>[] {
	const lowerFilterValue = filterValue.toLowerCase();

	function rowFilter(row: Row<Object>): boolean {
		const rowValue = row.values[id];

		if (rowValue !== undefined) {
			return String(rowValue).toLowerCase().indexOf(lowerFilterValue) !== -1;
		} else {
			return true;
		}
	}

	return rows.filter(rowFilter);
}